// extracted by mini-css-extract-plugin
export default {"spin":"dataTable-modulespin-Bhdyv"};